var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#6930CA",
    stroke: "#6930CA",
    strokeWidth: 15,
    r: 15,
    cx: 40,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#6930CA",
    stroke: "#6930CA",
    strokeWidth: 15,
    r: 15,
    cx: 100,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#6930CA",
    stroke: "#6930CA",
    strokeWidth: 15,
    r: 15,
    cx: 160,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d92c53f4de0ce873127f9cbd10bad47a.svg";
export { ForwardRef as ReactComponent };